export default {
    params: {
      seller_id : null,
      date_from: null,
      date_up : null,
    },
    ag_grid:{
      selectedTheme:'ag-theme-balham'
    },
    commisionSaleBrands:[],
    sellers:[],
    loading:{
      preloader:false,
      commisionSaleBrands:true,
    }
  };
  


// WEBPACK FOOTER //
// ./src/modules/commission-sale-brand/state.js